import styled from 'styled-components';

import { Text } from './Text';
import theme from '../theme';

const DescriptionText = styled(Text)`
  && {
    color: ${theme.gray8};
    font-size: 12px;
  }
`;

export default DescriptionText;
